import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Loader from './components/layout/Loader';
import ConsentPopup from './components/layout/ConsentPopup';
import ScrollToTop from './components/layout/ScrollToTop';
import Home from './pages/Home';
import TheFirm from './pages/TheFirm';
import TheLeadership from './pages/TheLeadership';
import Documentations from './pages/Documentations';
import Contact from './pages/Contact';
import FamilyMatters from './pages/FamilyMatters';
import CivilMatters from './pages/CivilMatters';
import CriminalMatters from './pages/CriminalMatters';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      {loading && <Loader onLoadingComplete={() => setLoading(false)} />}
      <ConsentPopup />
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            
            {/* About Routes - Updated */}
            <Route path="/about/firm" element={<TheFirm />} />
            <Route path="/about/leadership" element={<TheLeadership />} />
            
            {/* Practice Routes */}
            <Route path="/practices/family-matters" element={<FamilyMatters />} />
            <Route path="/practices/civil-matters" element={<CivilMatters />} />
            <Route path="/practices/criminal-matters" element={<CriminalMatters />} />
            
            {/* Other Routes */}
            <Route path="/documentations" element={<Documentations />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;